import { FC, FormEvent, MouseEvent, useEffect, useRef, useState } from "react"
import { NoProps } from "../../shared/types"
import { Logger } from "../../shared/Logger"
import { getThreads, ThreadSummary, ThreadData, getThread, Post, postToThread, getPreviewOfPost } from "../../services/BoardData"
import { NavLink, useLocation, useParams } from "react-router-dom"
import Markdown from "react-markdown"
import SubmitButton from "../../widgets/ButtonSubmit"
import NavlinkOutline from "../../widgets/NavlinkOutline"
import { stripJavascript } from "./BoardUtils"

type ThreadProps = {
  threadId: string
}

type State = {
  thread?: ThreadData
  threadId: string
  wasPreviewPost: boolean
}

const Thread: FC<NoProps> = () => {
  const params = useParams()
  const [state, setState] = useState({ threadId: params['threadId'], wasPreviewPost: false } as State)
  Logger.info(`thread render - ${JSON.stringify(location)} ${JSON.stringify(state)} `)
  useEffect(() => {
    getThread({ threadId: state.threadId }).then(thread => setState({ ...state, thread }))
  }, [getThreads, state.threadId])

  const textEntryField = useRef<HTMLInputElement>(null)

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
  }

  const handlePostClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault()
    const body = textEntryField?.current?.value || ''
    postToThread({ threadId: state.threadId, body }).then(thread => {
      setState({ ...state, thread, wasPreviewPost: false })
    })

    textEntryField.current && (textEntryField.current.value = '')
  }

  const handlePreviewClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault()
    const body = textEntryField?.current?.value || ''
    getPreviewOfPost({ threadId: state.threadId, body }).then(thread => {
      setState({ ...state, thread, wasPreviewPost: true })
    })
  }

  return (
    <div className="container mx-auto">
      {!state.thread && <h1>loading</h1>}
      {state.thread && <div>
        <h1>{state.thread.title}</h1>
        {state.thread?.postList.posts.map(getPostLine)}
        <div className="w-full flex">
          <form className="p-2 pb-0 w-full flex" onSubmit={handleSubmit}>
            <input
              className="mt-3 flex-grow max-w-96"
              type="text"
              placeholder="what's on your mind, friend?"
              id="customTextField"
              ref={textEntryField}
            />
          </form>
        </div>
        <div className="pt-10 ">
          <NavlinkOutline toPath="/board" linkText="back to the shit..." />
          <SubmitButton clickHandler={handlePostClick} buttonText="post" />
          <SubmitButton clickHandler={handlePreviewClick} buttonText="preview" />
        </div>
      </div>}
    </div>
  )
}

function getPostLine(post: Post, index: number) {
  return (
    <div className="w-full pt-6" key={'chatline-' + index}>
      <div className="mx-10 text-xs font-bold">{post.authorHandle}{' - '}{post.postDate.toLocaleDateString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
      })}</div>
      <div className="text-s font-light">{post.textMode === 'markdown' ? <Markdown>{stripJavascript(post.body)}</Markdown> : stripJavascript(post.body)}</div>
    </div>
  )
}

export default Thread